// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"0fa2a209","833":"029ca694"}[chunkId] + ".chunk.js";
};